<template>
    <div
        id="list-delivery-options-component"
        class="w-full h-full flex flex-col"
    >
        <custom-simple-select
            v-if="enabled"
            v-model="option"
            label="Tipo de entrega"
            :options="selectOptions"
            @change="onInput"
        />
        <div v-else class="flex flex-col pl-2 pt-2">
            <strong>Tipo de entrega </strong>
            <span class="mt-2 ml-2">
                {{ $data.$deliveryOptionsCodes[itemCurrent] }}
            </span>
        </div>
    </div>
</template>

<script>
import { deliveryOptionsCodes } from "@/common/fields/delivery-options";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "DeliveryOptionSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "home",
            type: String,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: "",
        $deliveryOptionsCodes: deliveryOptionsCodes
    }),
    computed: {
        selectOptions() {
            return Object.entries(this.$data.$deliveryOptionsCodes).map(
                ([key, value]) => ({ label: value, value: key })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.option = value;
        }
    },
    mounted() {
        this.option = this.itemCurrent;
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        }
    }
};
</script>
